import {VehicleOdometerReadingModel} from './vehicle-odometer-reading.model';
import {VehicleBrandsModel} from '../shared/vehicle-brands/vehicle-brands.model';
import {ValidationResultModel} from '../../shared/models/validation-results/validation-result.model';
import { NoteViewModel } from '../../note/models/views/note-view.model';
import { VehicleAddressModel } from './vehicle-address.model';
import { ProhibitionModel } from './prohibition.model';

export class VehicleModel {

    constructor() {
        this.validationResults = new Array<ValidationResultModel>();
        this.prohibitions = new Array<ProhibitionModel>();
        this.notes = new Array<NoteViewModel>();
    }

    id: number;
    vehicleNumber: number;
    vehicleBodyStyleTypeMapID: number;
    vehicleTypeID: number;
    bodyStyleTypeID: number;
    bodyStyleTypeDisplayValue: string;
    fuelTypeID: number;
    makeID: number;
    makeDisplayValue: string;
    makeNCICValue: string;
    modelID: number;
    modelDisplayValue: string;
    primaryColorTypeID: number;
    secondaryColorTypeID: number;
    grossVehicleWeight: number;
    grossVehicleWeightRatingTypeID: number;
    vin: string;
    shortVIN: string;
    vinTypeID: number;
    factoryListPrice: number;
    originalFactoryListPrice: number;
    purchasePrice: number;
    purchaseDate: Date;
    modelYear: number;
    unladenWeight: number;
    axles: number;
    active: boolean;
    monthFirstRegistered: number;
    yearFirstRegistered: number;
    tonnageRatingTypeID: number;
    permanentRegistrationDate: Date;
    isEnergyEfficient: boolean;
    trailerLength: number;
    trailerWidth: number;
    updatedBy: string;
    updatedDate: string;
    vehicleOdometerReading: VehicleOdometerReadingModel;
    vehicleAddress: VehicleAddressModel;
    vehiclePermits: any[];
    vehicleBrands: VehicleBrandsModel[];
    nmvtisBrands: VehicleBrandsModel[];
    newVehicleBrand: VehicleBrandsModel;
    notes: NoteViewModel[];
    validationResults: ValidationResultModel[];
    prohibitions: ProhibitionModel[];
    vinPatternId: number;
    selectedVinPatternId: number;
    isApportioned: boolean;
    combinedAxles: number;
    seats: number | null;
    alternativeFuelTierTypeId: number;
    unitNumber: string;
    plateNumber: string;

    registrationStartDate: Date | null;
    registrationEndDate: Date | null;
}
